import { render, staticRenderFns } from "./ReportDetailDetail.vue?vue&type=template&id=6060ee4a&scoped=true&"
import script from "./ReportDetailDetail.vue?vue&type=script&lang=js&"
export * from "./ReportDetailDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailDetail.vue?vue&type=style&index=0&id=6060ee4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060ee4a",
  null
  
)

export default component.exports